
// This is the general purpose app-wide store.
import { defineStore } from 'pinia'
import { backend_api_v2 } from "/src/utils/apiv2";
import { useFactoriesStore } from './factories';

export const usePlanningStore = defineStore('planning', {
    state: () => ({
        designs_on_load: [],
        designs_cache: [],
    }),
    actions: {
        set_to_cache(design) { this.designs_cache = [...this.designs_cache, design] },
        load_designs(uuids) {
            if (uuids.every(uuid => this.designs_on_load.includes(uuid))) {
                return Promise.resolve()
            } else {
                const to_load_uuids = uuids.filter(uuid => !this.designs_on_load.includes(uuid))
                this.designs_on_load.push(...to_load_uuids)
                return backend_api_v2.post('constructibles/assembly_designs/get_by_uuids/', to_load_uuids)
                    .then(({ data }) => {
                        data.forEach(obj => this.set_to_cache(obj))
                        this.designs_on_load = this.designs_on_load.filter(u => !to_load_uuids.includes(u))
                        return { data }
                    }).catch(e => console.log(`Cant load assemblies: ${e}`))
            }
        },
    },
    getters: {
        are_designs_loading: state => uuids => {
            return uuids.some(uuid => state.designs_on_load.includes(uuid))
        },
        get_designs_from_cache: state => uuids => {
            return state.designs_cache.filter(des => uuids.includes(des.uuid))
        },
        get_design_expected_worktime: state => (design_uuid, pl_uuid) => {
            // get PL stations
            const factories_store = useFactoriesStore()
            const production_line = factories_store.production_lines.find(pl => pl.uuid == pl_uuid)
            if (!production_line) return 0
            const stations = production_line.stations.map(sta_uuid => factories_store.stations.find(sta => sta.uuid == sta_uuid))
            // get design
            const design = state.designs_cache.find(des => des.uuid == design_uuid)
            if (!design) return 0
            const des_area = (design.meta?.metrics?.bruto || 0)
            // get zone branches map
            const zbm = design.meta?.zone_branches_map || {}
            // zbm = {
            // "zone": ["branch1", "branch2", ...],
            // }
            let total_time = 0
            stations.forEach(station => {
                const station_zones = station.zones || []
                const expected_wt_sqmt = parseInt(station.meta?.expected_worktime) || 0
                const expected_wt = expected_wt_sqmt * des_area
                // if one of the zones of the design is in the station zones, add the time
                // Parse to integers
                const str_sta_zones = station_zones.map(z => String(z))
                const has_zone = Object.keys(zbm).some(z => {
                    const sz = String(z)
                    if (!str_sta_zones.includes(sz)) return false
                    if (zbm[sz].length == 0 || zbm[parseInt(sz)].length == 0) return false
                    return true
                })
                if (has_zone || station_zones.length == 0) {
                    total_time += expected_wt
                }
            })
            // Tweak factor
            const tweak_str = String(design.client_meta?.worktime_tweak_factor || "1").replace(",", ".")
            const tweak = parseFloat(tweak_str)
            total_time = total_time * tweak

            return Math.round(total_time)
        },
    }
})